/**
 * <ModuleGate slug="marketing">
 *   <MarketingPage />
 * </ModuleGate>
 *
 * Cache le contenu si le module n'est pas activé pour l'agence du user,
 * et affiche un CTA "Module non activé" à la place.
 *
 * Props :
 *  - slug        : slug du module (ex: 'marketing')
 *  - fallback    : ReactNode custom (sinon CTA par défaut)
 *  - hideSilent  : si true, ne rend rien quand désactivé (au lieu du CTA)
 */
import React from 'react';
import { useModuleAccess } from '../lib/featureFlags';

const DefaultLocked = ({ slug }) => (
  <div
    className="max-w-2xl mx-auto my-12 p-8 rounded-2xl border border-amber-200 bg-amber-50 text-center"
    data-testid={`module-gate-locked-${slug}`}
  >
    <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-amber-100 flex items-center justify-center">
      <i className="bi bi-lock text-amber-600 text-2xl"></i>
    </div>
    <h3 className="text-lg font-bold text-slate-800 mb-2">Module non activé</h3>
    <p className="text-sm text-slate-600 mb-4">
      Cette fonctionnalité n'est pas incluse dans le forfait actuel de votre agence.
    </p>
    <p className="text-xs text-slate-500">
      Contactez l'administrateur Komerces pour l'activer.
    </p>
    <div className="mt-4 inline-block px-3 py-1 rounded-full bg-white text-xs font-mono text-slate-500 border border-slate-200">
      module: <span className="font-semibold text-amber-700">{slug}</span>
    </div>
  </div>
);

const Loading = () => (
  <div className="py-12 text-center text-sm text-slate-400">
    <i className="bi bi-arrow-clockwise animate-spin mr-2"></i>Chargement…
  </div>
);

export default function ModuleGate({ slug, children, fallback, hideSilent = false }) {
  const { enabled, loading } = useModuleAccess(slug);
  if (loading) return <Loading />;
  if (!enabled) {
    if (hideSilent) return null;
    return fallback || <DefaultLocked slug={slug} />;
  }
  return <>{children}</>;
}
